import React from 'react'

import { Button } from '~/components/Buttons'
import { useAppInfo } from '~/hooks/useAppInfo'

import { useCampaignForm } from '../hooks/useCampaignForm'

const DebugModeToggle: React.FC = () => {
  const { toggleDebugMode } = useCampaignForm()
  const { superAdmin } = useAppInfo()

  if (!superAdmin) return null

  return (
    <footer className="text-center fs-6 border-top mt-3 py-1">
      <Button template="transparent" size="xsmall" onClick={toggleDebugMode}>
        <small>Toggle debug mode</small>
      </Button>
    </footer>
  )
}

export default DebugModeToggle
